// extracted by mini-css-extract-plugin
module.exports = {"Page":"LocationManagerBooking_Page__GuHJ3","Selection":"LocationManagerBooking_Selection__1SX1t"};